<template>
  <div class="full-calendar-body">
    <div class="weeks">
      <strong v-for="(weekday, i) in weekDays" :key="i" class="week">{{ weekday }}</strong>
    </div>
    <div class="dates">
      <div class="dates-bg">
        <div v-for="(week, i) in days" :key="i" class="week-row">
          <t-calendar-cell v-for="(day, j) in week" :key="j" :date="day"></t-calendar-cell>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TCalendarCell from './calendar-cell'

export default {
  name: 'TCalendarBody',
  components: {
    TCalendarCell
  },
  props: {
    date: {
      type: Object,
      default: null
    },
    thisDate: {
      type: Object,
      default: null
    },
    weekDays: {
      type: Array,
      default() {
        return []
      }
    },
    firstDay: {
      type: Number,
      default: 0
    }
  },
  computed: {
    days() {
      return this.$_calendar()
    }
  },
  methods: {
    $_renderDate(day) {
      return <p class="day-number">{ day.date }</p>
    },
    $_calendar() {
      // console.log(this.date.format('YYYY-MM-DD'))
      let calendar = []
      let cloned = this.date.clone()
      let start = cloned.date(1)
      let diff = this.firstDay - start.day()
      start = start.date(1 + diff)
      for (let w = 0; w < 6; w++) {
        let week = []
        for (let d = 0; d < 7; d++) {
          let currentDay = start.date()
          week.push({
            date: currentDay,
            valid: start.month() === this.date.month(),
            isSelected: false,
            isToday: start.isSame(this.thisDate)
          })
          start = start.date(currentDay + 1)
        }
        calendar.push(week)
      }
      return calendar
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/module/calendar/calendar-body.vue